import Head from 'next/head'
import urlJoin from 'url-join'

import { env } from '@/shared/config'

export type PageHeadProps =
    | {
          disablePageIndexing: true
          path?: never
      }
    | {
          disablePageIndexing?: false
          path: string
      }

export function PageHead(props: PageHeadProps) {
    if (env.DISABLE_SEARCH_ENGINE_CRAWLING || props.disablePageIndexing) {
        return (
            <Head>
                <meta name="robots" content="noindex, nofollow" />
            </Head>
        )
    }

    return (
        <Head>
            {/*TODO может не нужен x-default - по идее портал еще на прокси редиректит на /en*/}
            <link rel="alternate" href={urlJoin(env.PUBLIC_URL, props.path)} hrefLang="x-default" />

            {env.LANG_LIST.map((lang) => {
                let hreflang: string
                if (lang === 'cn') {
                    hreflang = 'zh-Hans'
                } else if (lang === 'tw') {
                    hreflang = 'zh-Hant'
                } else {
                    hreflang = lang
                }

                return (
                    <link
                        key={lang}
                        rel="alternate"
                        href={urlJoin(env.PUBLIC_URL, lang, props.path)}
                        hrefLang={hreflang}
                    />
                )
            })}
        </Head>
    )
}
